<main class="page-main">
	<section class="page-section" id="sectionOverview">
		<h2 id="sectionTitleOverview" class="page-section-no-link-title">
			All guidelines
		</h2>
		<ul class="overview-list">
			<li *ngFor="let item of filterItems(navData, 'guidelines')" class="overview-list-item">
				<div class="overview-list-item-container">
					<div class="overview-list-item-detail-image" (click)="redirectTo(item.route)">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
							<path
								d="M240 16C240 7.164 247.2 0 256 0C264.8 0 272 7.164 272 16V32H440.3C445.2 32 449.8 34.21 452.8 38L504 102C508.7 107.8 508.7 116.2 504 121.1L452.8 185.1C449.8 189.8 445.2 192 440.3 192H272V224H448C465.7 224 480 238.3 480 256V352C480 369.7 465.7 384 448 384H272V496C272 504.8 264.8 512 256 512C247.2 512 240 504.8 240 496V384H71.69C66.83 384 62.23 381.8 59.2 377.1L7.996 313.1C3.322 308.2 3.322 299.8 7.996 294L59.2 230C62.23 226.2 66.83 224 71.69 224H240V192H64C46.33 192 32 177.7 32 160V64C32 46.33 46.33 32 64 32H240V16zM432.6 64H64V160H432.6L471 112L432.6 64zM40.98 304L79.38 352H448V256H79.38L40.98 304z" />
						</svg>
					</div>
					<div class="overview-list-item-detail-container" (click)="redirectTo(item.route)">
						<span class="overview-list-item-detail-title">
							{{ item.name }}
						</span>
						<span class="overview-list-item-detail-sub-title">
							{{ item.description }}
						</span>
					</div>
				</div>
			</li>
		</ul>
	</section>
</main>
